<div [formGroup]="form">

    <app-date-range-inlinePicker *ngIf="dateType == 'date_range'" [selected]='selected' [product]="product" [disabledDates]="disabledDates" [range]="form.get('dateRange')" [timeType]="timeType" [form]="form"></app-date-range-inlinePicker>

    <app-single-date-inlinePicker class="w-full h-full" *ngIf="dateType == 'single_date'" [product]="product" [disabledDates]="disabledDates" [timeslots]="timeslots" [date]="form.get('date')" [timeType]="timeType" [form]="form"></app-single-date-inlinePicker>

    <app-multi-day-picker class="w-full h-full" *ngIf="dateType == 'multi_date' && product && form.get('dates')" [timeType]="timeType" [form]="form" [disabledDates]="disabledDates" [product]="product" [dates]="form.get('dates')"></app-multi-day-picker>


    <!--    <div class="container mt-3">
        <div class="d-flex justify-content-end" style="gap: 0.5rem;">
            <button type="button" (click)="addToCart()" class="btn btn-primary" style="flex-grow: 0;" [ngClass]="{'btn-loading': addingToCart}">
                <div class="label">{{"add_cart"|translate}}</div>
            </button>
            <ng-container *ngIf="isQuotable && tab == 'summary'">
                <button eventCollector eventName="add_to_quotation" category="product_page" itemType="service" [companyId]="product.companyData?._id" [productId]="product._id" type="button" [disabled]="amount.value < product?.minQuotationAmount" (click)="addQuotation()"
                    [ngClass]="{'btn-loading': addingToCart}" class="btn btn-primary">{{"add_quotation"|translate}}</button>
            </ng-container>
        </div>
    </div> -->
</div>


<ng-template #modal>
    <div class="modal-header">
        <h2 class="headline m-0" fxFlex="auto">{{"add_quotation"|translate}}</h2>
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
        </button>
    </div>
    <div class="modal-body scroll">
        <div class="quickview" *ngIf="product.images">
            <div class="product product--layout--quickview">
                <div class="product__content">
                    <div class="product__gallery">
                        <app-product-gallery [productLayout]="'quickview'" [images]="product.images">
                        </app-product-gallery>
                    </div>
                    <div class="product__info">
                        <h1 class="product__name">{{ translateHelper.localize(product.name) }}</h1>
                        <div class="product__prices" *ngIf="!product.hidePrice">
                            {{ product.taxedPrice || product.price|currencyFormat }}
                        </div>
                        <div *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                            <span style="font-size:  small;" class="my-2">{{"inclusive"|translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" [ngClass]="{'btn-loading': addingToCart}" (click)="bsModalRef.hide()" (click)="addToList()" type="button">
            {{"add_quotation_list"|translate}}
        </button>
        <button class="btn btn-primary" [ngClass]="{'btn-loading': addingToCart}" type="button" (click)="requestQuotation()">{{"get_single_quotation"|translate}}</button>
    </div>
</ng-template>